import { c as _c } from "react/compiler-runtime";
import React from 'react';
import PropTypes from 'prop-types';
import NotificationBannerSkeleton from './NotificationBannerSkeleton';
const UserOrdersSubmitReviewPhotoBanner = t0 => {
  const $ = _c(3);
  const {
    submitType,
    productName
  } = t0;
  let t1;
  if ($[0] !== productName || $[1] !== submitType) {
    t1 = <NotificationBannerSkeleton title="Congrats! Submission successful." body={<>Your {submitType} has been submitted for {productName}.</>} />;
    $[0] = productName;
    $[1] = submitType;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
};
UserOrdersSubmitReviewPhotoBanner.propTypes = {
  submitType: PropTypes.string,
  productName: PropTypes.string
};
export default UserOrdersSubmitReviewPhotoBanner;